// export const SERVER = `https://develop.applet.trailerman.cn`;
export const SERVER = `https://versiond.trailerman.cn`;